import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SplitButtonModule } from 'primeng/splitbutton';
import { HrmsService } from '../../../services/hrms.service';
import { AdministratorService } from '../../../services/administrator.service';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SharedModule } from '../../../shared/shared.module';
import { Router } from '@angular/router';

@Component({
  selector: 'app-calendar',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CardModule,
    ToastModule,
    SplitButtonModule,
    FullCalendarModule,
    SharedModule
  ],
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [MessageService]
})
export class CalendarComponent implements OnInit {
  AttendanceList: any[] = [];
  loader = false;
  empId: any;
  selectedViewLabel = 'Calendar';

  viewOptions = [
    { label: 'Calendar', icon: 'pi pi-calendar', command: () => this.setView('calendar') }
  ];

  layoutType: 'calendar' = 'calendar';

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    eventClick: (arg) => this.handleCalendarClick(arg),
    events: [],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    eventContent: (arg) => {
      return { html: `<div class="fc-event-title">${arg.event.title}</div>` };
    }
  };

  constructor(
    private hrmsService: HrmsService,
    private administratorService: AdministratorService,
    private messageService: MessageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const auth = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId: number = auth?.user?.id;
    if (userId) {
      this.getEmployeeIdByUserId(userId);
    } else {
      this.getAttendance();
    }
  }

  getEmployeeIdByUserId(userId: number): void {
    this.administratorService.getAllUser().subscribe({
      next: (users: any[]) => {
        const currentUser = users.find(u => u.userId === userId);
        if (currentUser && currentUser.empId) {
          this.empId = currentUser.empId;
          this.getAttendance();
        } else {
          console.warn('Employee ID not found for current user');
          this.getAttendance();
        }
      },
      error: (err) => {
        console.error('Failed to fetch user list', err);
        this.getAttendance();
      }
    });
  }

  setView(view: 'calendar') {
    this.layoutType = view;
    this.selectedViewLabel = 'Calendar';
    this.loadAttendanceAsEvents();
  }

  getAttendance(): void {
    this.loader = true;
    const payload = {
      pageIndex: 0,
      pageSize: 200,
      id: 0,
      empId: this.empId
    };

    this.hrmsService.getAttendance(payload).subscribe({
      next: (data: any) => {
        let attendances = data?.attendances || [];
        if (this.empId) {
          attendances = attendances.filter((a: any) => a.empId === this.empId);
        }
        this.AttendanceList = attendances;
        this.loadAttendanceAsEvents();
        this.loader = false;
      },
      error: () => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load attendance data'
        });
      }
    });
  }

  loadAttendanceAsEvents() {
    if (!this.AttendanceList || this.AttendanceList.length === 0) return;

    const events = this.AttendanceList.map((att: any) => {
      let title = att.checkIn && att.checkOut
        ? `✓ In: ${att.checkIn} | Out: ${att.checkOut} (${att.totalHours || '-'})`
        : att.checkIn
          ? `✓ In: ${att.checkIn} | Out: Pending`
          : `Status: ${att.status || 'N/A'}`;

      let color = att.checkIn && att.checkOut
        ? '#10b981'
        : att.checkIn
          ? '#f59e0b'
          : '#9ca3af';

      return {
        title,
        date: att.date,
        backgroundColor: color,
        borderColor: color,
        textColor: '#ffffff',
        id: att.attendanceId
      };
    });

    this.calendarOptions.events = events;
  }

  handleCalendarClick(arg: any) {
    const attendance = this.AttendanceList.find(a => a.attendanceId == arg.event.id);
    if (attendance) {
      this.messageService.add({
        severity: 'info',
        summary: 'Attendance Details',
        detail: `Date: ${attendance.date} | Check In: ${attendance.checkIn || 'N/A'} | Check Out: ${attendance.checkOut || 'N/A'} | Hours: ${attendance.totalHours || 'N/A'}`
      });
    }
  }

  refreshAttendance() {
    this.getAttendance();
  }

  exportAttendance() {
    this.loader = false;
  }

  cancel() {
    this.router.navigate(['/home/hrmsdashboard']);
  }
}
